<gs1-header
  rootLink="/hub"
  [img]="'../assets/images/logo-gs1-france.png'"
  [breakWidth]="1080"
  [connected]="isLoggedIn"
  [showDisconnect]="false"
  [appName]="'Espace Client'"
  [profileLabel]="'header.profil' | translate"
  class="fix"
>
  @if (!isFederation()) {
    <a name="header-home" routerLinkActive="active" routerLink="/hub">{{ 'header.home' | translate }}</a>
  }
  @if (!isFederation()) {
    <a name="header-company" routerLinkActive="active" routerLink="/entreprise">
      {{ 'header.Entreprise.title' | translate }}
      @if (companyDisplay()) {
        <div gs1HeaderMenu>
          <span class="gs1-color-ui-8 entreprise-name"><i class="bi bi-house"></i>{{ nomEntreprise }}</span>
          <a name="header-company-info" routerLink="/entreprise/compte-entreprise">{{
            'header.Entreprise.info' | translate
          }}</a>
          <a name="header-company-activity" routerLink="/entreprise/activite">{{
            'header.Entreprise.activity' | translate
          }}</a>
          @if (companyDisplay().activateCA) {
            <a name="header-company-ca" routerLink="/entreprise/chiffre-affaire">{{
              'header.Entreprise.ca' | translate
            }}</a>
          }
          @if (companyDisplay().activateSEPA) {
            <a name="header-company-sepa" routerLink="/entreprise/moyens-de-paiement">{{
              'header.Entreprise.sepa' | translate
            }}</a>
          }
          @if (companyDisplay().activateLogo) {
            <a name="header-company-medias" routerLink="/entreprise/medias">{{
              'header.Entreprise.medias' | translate
            }}</a>
          }
          @if (companyDisplay().activatePacks && !disablePackSetting) {
            <a name="header-company-packs" routerLink="/entreprise/pack">{{ 'header.Entreprise.packs' | translate }}</a>
          }
          @if (multiple) {
            <a
              id="company-change"
              gs1Button
              [name]="'company-change'"
              (click)="changeCompany()"
              [color]="'sky'"
              [thin]="true"
              >{{ 'header.changerEntreprise' | translate }}</a
            >
          }
        </div>
      }
    </a>
  }

  @if (!isFederation()) {
    <a name="header-bills" routerLinkActive="active" routerLink="/factures">{{ 'header.billing' | translate }}</a>
  }
  @if (!isFederation()) {
    <a name="header-doc" routerLinkActive="active" routerLink="/documents">{{ 'header.documents' | translate }}</a>
  }
  @if (!isFederation()) {
    <a name="header-codes" routerLinkActive="active" routerLink="/codes">{{ 'header.codes' | translate }}</a>
  }
  @if (!isFederation()) {
    <a name="header-users" routerLinkActive="active" routerLink="/utilisateurs">{{ 'header.users' | translate }}</a>
  }

  <div id="account-popin">
    <div class="utilisateur-info">
      <span class="name gs1-little">{{ nomComplet }}</span>
      <span class="email gs1-small">{{ emailAdherent }}</span>
    </div>
    @if (!isFederation()) {
      <a name="header-profile" class="gs1-little gs1-color-blue" [routerLink]="['/formulaire-donnee-perso']">
        <i class="bi bi-gear"></i> {{ 'header.manage' | translate }}
      </a>
    }
    <a name="header-logout" class="gs1-little" (click)="logout()"
      ><i class="bi bi-box-arrow-right"></i> {{ 'header.deconnecter' | translate }}</a
    >
  </div>
</gs1-header>
